import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'baseui/snackbar'
import { useTranslation } from 'react-i18next'

import { selectCommandsStoreData } from './commandsSelectors'
import { setCommand, reset } from './commandsSlice'
import { commandsActions } from './commandsSagas'

const useCommands = () => {
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { t } = useTranslation('devToolsNew')

  const { command, commandsList, isLoadingList, listError, output, isExecuting, executeError, executeSuccess } =
    useSelector(selectCommandsStoreData)

  useEffect(() => {
    dispatch(reset())
    dispatch({ type: commandsActions.FETCH_LIST, t })
  }, [])

  const onCommandChange = value => dispatch(setCommand(value))

  const onExecute = () => {
    if (!command) return
    dispatch({
      type: commandsActions.EXECUTE,
      enqueue,
      t,
      payload: { command },
    })
  }

  return {
    form: {
      command,
      commandsList,
      isLoadingList,
      listError,
      output,
      isExecuting,
      onCommandChange,
      onExecute,
    },
    result: {
      error: executeError,
      success: executeSuccess,
    },
    t,
  }
}

export default useCommands
